import React, { useCallback } from 'react';

// import URL from 'url';

import Grid from '@mui/material/Grid';
import { withStyles } from "@mui/styles";
import classnames from "classnames";
import defaultMetadata from "../../defaultMetadata";
import { useTheme, withTheme } from '@emotion/react';
import twitter from '../../assets/syneos_social/twitter.png'
import insta from '../../assets/syneos_social/insta.png'
import youtube from '../../assets/syneos_social/youtube.png'
import fb from '../../assets/syneos_social/fb.png'
import alma from '../../assets/alma.png'


const DropItem = () => <></>

const styles = (theme) =>{
    return {
        footer: {
            background: "#3A3F42",
            color: '#fff',
            padding: '44px 64px',
            [theme.breakpoints.down('md')]:{
                padding: '40px 24px'
            }
        },
        logosItem:{
            [theme.breakpoints.down('md')]:{
                alignSelf: 'flex-start'
            }
        },
        email_link:{
            "&:hover":{
                textDecoration: "underline"
            }
        }
    }
};


const Footer = (props) => {

    const logoComponent = () => {
        const {logo, footer_address_name} = defaultMetadata;
        return (
            <React.Fragment>
                <Grid container item xs={12} sm={4} md={3} direction="column" alignItems="right">
                    {/* <div className="text_title" style={{color: '#FF9E1B', marginBottom: '16px'}}>ABOUT US</div> */}
                    {/* <Grid item> */}
                        <a href="https://www.syneoshealth.com/" className="margin-bottom-20 display-block"><img className="max-width-156" src={logo} alt="Logo"/></a>
                        {/* <div style={{marginBottom: 8, maxWidth: '320px'}}>{footer_address_name}</div> */}
                    {/* </Grid> */}
                </Grid>
            </React.Fragment>
        );
    }

    const quick_links = () => {
        return(
            <div></div>
        );
    }

    const {classes} = props;
    const {footer_links} = defaultMetadata;
    return (
        <React.Fragment>
            <div className="background-eb3300 height-16"></div>
            <div className={classes.footer+' text_title_small'}>
                <Grid container justifyContent="">
                    {logoComponent()}
                    <Grid container item xs={12} sm={8} md={6} direction="row">
                        <Grid item xs className="font-size-16 font-weight-600">
                            <div className="text_title color-ff9e1b margin-bottom-8">CONTACT US</div>
                            <Grid container justifyContent="space-between" alignItems="center">
                                <Grid item xs={12} sm={6} md={6}>                              
                                    <div>
                                        <div className="font-weight-800">Syneos Health Consulting Alumni</div>
                                        <a href="mailto:sm_alumni@syneoshealth.com" className={classes.email_link + ' margin-top-4'}>sm_alumni@syneoshealth.com</a>
                                    </div>
                                </Grid>
                            </Grid>
                            
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} sm={12} md={3} direction="column" alignItems="flex-end" className="font-size-14 font-weight-600">
                        <Grid item className={classes.logosItem}>
                            <div>
                                <a href="https://www.facebook.com/SyneosHealth/" target="_blank" rel="noopener noreferrer"><img className="width-24px margin-right-24" src={fb} alt="Facebook"/></a>
                                <a href="https://twitter.com/syneoshealth" target="_blank" rel="noopener noreferrer"><img className="width-24px margin-right-24" src={twitter} alt="X"/></a>
                                <a href="https://www.instagram.com/syneoshealth/?hl=en" target="_blank" rel="noopener noreferrer"><img className="width-24px margin-right-24" src={insta} alt="Instagram"/></a>
                                <a href="https://www.youtube.com/c/SyneosHealth" target="_blank" rel="noopener noreferrer"><img className="width-24px" src={youtube} alt="Youtube"/></a>
                            </div>
                            <div className="margin-top-24 default_flex_container">
                                <div className="margin-right-10 padding-15-0">Powered by</div>
                                <img className="width-100px" src={alma} alt="Logo"/>
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </React.Fragment>
    );

}

export default withStyles(styles, {withTheme: true})(withTheme((Footer)));
